import BehaviorConfig from '@/models/app-config/behavior/behavior'
import {
  CartLoginTemplateParts,
  defaultTemplate,
  fitowaTemplate,
  mycolorTemplate,
  vilbTemplate,
} from './template-parts'

export function createCartLoginTemplateParts(behavior: BehaviorConfig): CartLoginTemplateParts {
  if (behavior.isVilb) return vilbTemplate(behavior)

  if (behavior.isFitowa) return fitowaTemplate(behavior)

  if (behavior.isMyColor) return mycolorTemplate

  return defaultTemplate()(behavior)
}
